<template lang="pug">
.target-family-detail-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：利用者グループ
    template(#cell(groupName)="row")
      span {{ row.item.groupName }}
    // セル：利用者
    template(#cell(residentName)="row")
      span {{ row.item.name }}（{{ row.item.room }}）
    // セル：家族ユーザー
    template(#cell(familyName)="row")
      span {{ row.item.familyName }}（{{ row.item.familyRelation }}）
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * ### 文書送付、確認・同意ユーザー一覧テーブル
 */
@Component({})
export default class TargetFamilyDetailTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<TargetFamilyDetailTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<TargetFamilyDetailTableField>;

  get _value(): Array<TargetFamilyDetailTableItem> {
    return this.value;
  }

  public convertDateText(datetime: number): string {
    const date: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
    return date;
  }
}

/** テーブルの列名の情報 */
export interface TargetFamilyDetailTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface TargetFamilyDetailTableItem {
  /** 利用者ソートキー */
  residentsSortKey: string;
  /** 利用者グループID */
  groupId: number;
  /** 利用者グループ名 */
  groupName: string;
  /** 利用者ID */
  id: number;
  /** 利用者名 */
  name: string;
  /** 部屋ID */
  roomId: number;
  /** 部屋名 */
  room: string;
  /** 家族名 */
  familyName: string;
  /** 家族続柄 */
  familyRelation: string;
  /** 家族電話番号 */
  familyTel: string;
}
</script>
